<div class="container mb-5 md:mb-8" appSwipeScroll>
    <section class="flight-deals">
        <h2 class="text-5xl md:text-6xl">Recent Flight Deals</h2>
        <p class="subtitle-flight text-xl">
            We find incredible deals leaving your home airport to amazing destinations all over the world.
        </p>
    </section>
    <div *ngIf="viewport.isMobile" class="flex justify-content-end gap-4 p-3 w-full">
        <button
            type="button"
            class="bg-transparent border-none w-2rem h-1rem flex align-items-center justify-content-center text-900"
            (click)="flightCarousel?.navBackward($event)"
            aria-label="Previous"
        >
            <i class="pi pi-chevron-left text-2xl"></i>
        </button>
        <button
            type="button"
            class="bg-transparent border-none w-2rem h-1rem flex align-items-center justify-content-center text-900"
            (click)="flightCarousel?.navForward($event)"
            aria-label="Next"
        >
            <i class="pi pi-chevron-right text-2xl"></i>
        </button>
    </div>
<p-carousel #flightCarousel class="draggable flights" [value]="flightDeals" [numScroll]="1" [numVisible]="numVisible"
            [circular]="true" [showIndicators]="false" [showNavigators]="false" [autoplayInterval]="8000" >
    <ng-template let-deal let-i="index" pTemplate="item">
        <div class="deal-card">
            <img
                [src]="getResizedImage(deal.image, 377)"
                [attr.srcset]="getResizedImage(deal.image, 377) + ' 377w'"
                sizes="
         (min-width: 1200px) calc(16.39vw - 27px),
         (min-width: 1000px)  calc(20vw - 26px),
         (min-width: 780px)  calc(25.5vw - 24px),
         (min-width: 480px) calc(37.5vw - 37px),
         calc(60vw - 32px),
         calc(100vw / 1.5 - 16px)"
                [alt]="deal.route"
                loading="lazy"
                decoding="async"
            />
            <div class="deal-details">
                <h4>{{ deal.route }}</h4>
                <h2>${{ deal.currentPrice }} <span class="original-price">${{ deal.originalPrice }}</span></h2>
                <p>{{ deal.discount }}% Off</p>
            </div>
            <button class="deal-btn" (click)="redirect()" (mousedown)="blurMe($event)" style="color:black;" >Get deals</button>
        </div>
    </ng-template>
</p-carousel>
</div>
